module.exports = __webpack_public_path__ + "img/Teamtip_Logo_300x300.dce29fb4.png";